import { render, staticRenderFns } from "./selectPlatform.vue?vue&type=template&id=108e949b&"
import script from "./selectPlatform.vue?vue&type=script&lang=js&"
export * from "./selectPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports